import type { CSSProperties } from 'react';

/** A small, pleasant palette assigned to tags. Hex so we can tint with alpha. */
export const TAG_PALETTE = [
  '#6366f1', // indigo
  '#0ea5e9', // sky
  '#10b981', // emerald
  '#f59e0b', // amber
  '#ef4444', // red
  '#ec4899', // pink
  '#8b5cf6', // violet
  '#14b8a6', // teal
  '#f97316', // orange
  '#64748b', // slate
] as const;

/** Deterministic palette colour for a tag name — same name → same colour. */
export function tagColorForName(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) {
    hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  }
  return TAG_PALETTE[hash % TAG_PALETTE.length];
}

/** A tag's colour: its stored colour if set, else a stable one from its name
 *  (so legacy colourless tags still render colourful). */
export function resolveTagColor(tag: { name: string; color: string }): string {
  return tag.color || tagColorForName(tag.name);
}

/** Pastel-pill styling derived from a hex colour: tinted bg, coloured text +
 *  border. Falls back gracefully for non-hex values. */
export function tagChipStyle(color: string): CSSProperties {
  const isHex = /^#[0-9a-f]{6}$/i.test(color);
  if (!isHex) return {};
  return {
    backgroundColor: `${color}1a`, // ~10% alpha
    color,
    borderColor: `${color}55`, // ~33% alpha
  };
}
